__turbopack_context__.v({
  "activeFilters": "styles-module__gt68QG__activeFilters",
  "container": "styles-module__gt68QG__container",
  "desktopSortByFilter": "styles-module__gt68QG__desktopSortByFilter",
  "dropdownsContainer": "styles-module__gt68QG__dropdownsContainer",
  "filtersContainer": "styles-module__gt68QG__filtersContainer",
  "hidden": "styles-module__gt68QG__hidden",
  "mobileButton": "styles-module__gt68QG__mobileButton",
  "mobileControls": "styles-module__gt68QG__mobileControls",
  "mobileFilterButton": "styles-module__gt68QG__mobileFilterButton" + " " + "styles-module__gt68QG__mobileButton",
  "mobileFilterButton--active": "styles-module__gt68QG__mobileFilterButton--active",
  "mobileSortButton": "styles-module__gt68QG__mobileSortButton" + " " + "styles-module__gt68QG__mobileButton",
});
